import { render, staticRenderFns } from "./questions-panel-header.vue?vue&type=template&id=79e356e0&scoped=true&"
import script from "./questions-panel-header.vue?vue&type=script&lang=ts&"
export * from "./questions-panel-header.vue?vue&type=script&lang=ts&"
import style0 from "./questions-panel-header.vue?vue&type=style&index=0&id=79e356e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e356e0",
  null
  
)

export default component.exports